export default __webpack_public_path__ + "static/media/most_expensive_yachts.1a2ce8d8.webp";